import React, { useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../../../../common/Header";
import FooterInnerPagee from "../../../../common/FooterInnerPagee";
import image1 from "../../../../assets/people/peoplebannerimg.png";
import img1 from "../../../../assets/people/img1.jpeg";
import img2 from "../../../../assets/people/img2.jpeg";
import img3 from "../../../../assets/people/img3.jpg";
import img4 from "../../../../assets/people/img4.jpeg";
import img5 from "../../../../assets/people/img5.jpeg";
import img6 from "../../../../assets/people/img6.jpeg";
import img7 from "../../../../assets/people/img7.jpeg";
import img8 from "../../../../assets/people/img8.jpeg";
import img9 from "../../../../assets/people/img9.jpeg";
import img10 from "../../../../assets/people/img10.jpeg";
import img11 from "../../../../assets/people/img11.png";
import img12 from "../../../../assets/people/img12.jpeg";
import img13 from "../../../../assets/MohammedNisham.jpeg";

const Advisior = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const teamCategories = [
   
    {
      title: "Project Personals",
      members: [
        {
          src: img3,
          name: "Habeebulla",
          position: "Research Fellow",
          email: "nowshad@example.org",
          qualifications: [
            "Ph.D. in Marine Biology – University of Kerala",
            "M.Sc in Environmental Science – University of Calicut"
          ],
          description: "Working on field research and biodiversity projects."
        },
        {
          src: img9,
          name: "MOHAMMED SHAHEEM P",
          position: "Project Coordinator",
          email: "nowshad@example.org",
          qualifications: [
            "Ph.D. in Marine Biology – University of Kerala",
            "M.Sc in Environmental Science – University of Calicut"
          ],
          description: "Coordinates various conservation projects."
        },
        {
          src: img8,
          name: "Safair Ali Jereesh",
          position: "Environmental Education Coordinator",
          email: "nowshad@example.org",
          qualifications: [
            "Ph.D. in Marine Biology – University of Kerala",
            "M.Sc in Environmental Science – University of Calicut"
          ],
          description: "Focuses on education outreach programs."
        },
        {
          src: img7,
          name: "Abdulla",
          position: "Executive Member and MSDT Instructor",
          email: "nowshad@example.org",
          qualifications: [
            "Ph.D. in Marine Biology – University of Kerala",
            "M.Sc in Environmental Science – University of Calicut"
          ],
          description: "Trains and educates divers."
        },
        {
          src: img2,
          name: "Ilthmish Nasarulla",
          position: "Dive Master",
          email: "nowshad@example.org",
          qualifications: [
            "Ph.D. in Marine Biology – University of Kerala",
            "M.Sc in Environmental Science – University of Calicut"
          ],
          description: "Responsible for underwater research dives."
        },
        {
          src: img1,
          name: "Sharafudheen KM",
          position: "Dive Assistant",
          email: "nowshad@example.org",
          qualifications: [
            "Ph.D. in Marine Biology – University of Kerala",
            "M.Sc in Environmental Science – University of Calicut"
          ],
          description: "Supports diving and field work."
        },
        {
          src: img13,
          name: "Mohammed Nisham.P. P",
          position: "Dive Assistant",
          email: "nowshad@example.org",
          qualifications: [
            "Ph.D. in Marine Biology – University of Kerala",
            "M.Sc in Environmental Science – University of Calicut"
          ],
          description: "Assists in dive missions and logistics."
        },
        {
          src: img6,
          name: "Ajmeer Khan",
          position: "Field Assistant",
          email: "ajmeer@gmail.com",
          qualifications: [
            "Ph.D. in Marine Biology – University of Kerala",
            "M.Sc in Environmental Science – University of Calicut"
          ],
          description: "Supports field research activities."
        },
        {
          src: img5,
          name: "Mukbil",
          position: "Field Assistant",
          email: "mukhbilbaba@gmail.com",
          qualifications: [
            "Ph.D. in Marine Biology – University of Kerala",
            "M.Sc in Environmental Science – University of Calicut"
          ],
          description: "Engaged in on-site conservation tasks."
        }
      ]
    },

  ];

  return (
    <>
      <Grid container>
        <Header />
        <Grid
          item
          xs={12}
          sx={{
            height: { xs: "60vh", md: "70vh" },
            backgroundImage: `url(${image1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />

        {teamCategories.map((category, catIndex) => (
          <Grid
            key={catIndex}
            item
            xs={12}
            sx={{
              bgcolor: "#151d1f",
              color: "#fff",
              px: 6,
              py: 4,
              justifyContent: 'center',
              borderBottom: catIndex !== teamCategories.length - 1 ? "1px solid #444" : "none",
            }}
          >
            <Typography
              variant="h5"
              align="center"
              gutterBottom
              sx={{ fontWeight: "bold", mb: 3, fontFamily: "Montserrat, sans-serif", justifyContent: "center" }}
            >
              {category.title}
            </Typography>
            <Grid container spacing={3} justifyContent="center">
              {category.members.map((member, memIndex) => {
                const globalIndex = `${catIndex}-${memIndex}`;
                return (
                  <Grid item xs={12} sm={6} md={3} key={member.name} sx={{ display: "flex", justifyContent: "center" }}>
                    <Grid
                      sx={{
                        width: 250,
                        height: "100%",
                        borderRadius: 3,
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                      }}
                      onClick={() => navigate(`/profile/${globalIndex}`, { state: { member } })}
                    >
                      <Grid sx={{ height: 360, overflow: "hidden", flexShrink: 0 }}>
                        <img
                          src={member.src}
                          alt={member.name}
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      </Grid>
                      <Grid sx={{ p: 1 }}>
                        <Typography
                          variant="subtitle1"
                          fontWeight="bold"
                          color="#fff"
                          sx={{ fontFamily: "Montserrat, sans-serif" }}
                        >
                          {member.name}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="#fff"
                          sx={{ fontFamily: "Montserrat, sans-serif", letterSpacing: 0 }}
                        >
                          {member.position}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        ))}
      </Grid>
      <FooterInnerPagee />
    </>
  );
};

export default Advisior;